import {DraggableTree} from 'vue-draggable-nested-tree'

export default {
  name: 'update-parent',
  components: {Tree: DraggableTree},
  props: [],
  data () {
    return {
      doc_index: [],
      doc_item_init: this.document_items
    }
  },
  computed: {
    document_items () {
      return this.$store.getters['DocumentItem/getListDocumentItem']
    },
    document () {
      return this.$store.getters['Document/getDocument']
    }
  },
  mounted () {
  
    // this.loading = true
    Promise.all([
      _.isEmpty(this.document) ? this.$store.dispatch('Document/showDocument', {document: {id: this.$route.params.document_id}}): '',
      this.document_items == '' ? this.$store.dispatch('DocumentItem/getListDocumentItem', {document: {id: this.$route.params.document_id}}): ''
    ]).then(res => {
      
      
      this.loading = false
    }).catch(errors => {
      
      this.loading = false
    })
  },
  methods: {
    recursiveDocItem (arr, parent_id) {
      for (var i in arr) {
        let item = {}
        if (arr[i].children.length != 0) {
          this.recursiveDocItem(arr[i].children, arr[i].id)
        }
        if(arr[i].parent_id != parent_id ){ 
          item.id = arr[i].id
          item.parent_id = parent_id
          this.doc_index.push(item)
        }
      }
    },

    save(){
    
      this.recursiveDocItem(this.document_items, 0)
      this.$store.dispatch('DocumentItem/updateNodeDocumentItem',{data: this.doc_index, doc: this.$route.params.document_id}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        
      }).catch(errors => {
        
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/document-item/updateParent/updateParent.js